module.exports = __webpack_public_path__ + "img/travel_4.b41d7ec5.svg";